import axios from "axios";
import { track, EVENTS } from "@/lib/track";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// One-liner instrumentation: every successful POST /shortlist emits the
// `shortlist.added` event. Keeps the client-side call sites clean and
// guarantees we never miss an add-to-shortlist path.
api.interceptors.response.use((res) => {
  try {
    const cfg = res.config || {};
    const method = (cfg.method || "").toUpperCase();
    const url = cfg.url || "";
    if (method === "POST" && url.endsWith("/shortlist")) {
      let body = cfg.data;
      if (typeof body === "string") { try { body = JSON.parse(body); } catch { body = {}; } }
      track(EVENTS.SHORTLIST_ADDED, {
        degree_id: body?.degree_id || null,
        university_id: body?.university_id || null,
      });
    }
  } catch { /* instrumentation must never break the response */ }
  return res;
}, (err) => {
  // Site gate expired or was locked elsewhere: switch to the password screen (SiteGateBoundary).
  if (err?.response?.status === 401 && err.response.data?.code === "site_locked") window.dispatchEvent(new Event("wua:site-locked"));
  return Promise.reject(err);
});
